import { ConstantService } from './constantService/constant.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class LoginService {
  scope:any;    
  apiUrl=ConstantService.API_ENDPOINT;
  headers: any;
  userId:any;
  accessToken:any;
    httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    
    
    constructor(
      private http:HttpClient
    ) {  this.headers = new Headers();
  
      this.headers.append("Access-Control-Allow-Origin", "*");
      this.headers.append(
        "Access-Control-Allow-Methods",
        "POST, GET, OPTIONS, PUT"
      );
      this.headers.append("Accept", "application/json");
      this.headers.append("content-type", "application/json");
      this.getLoginUserData();
    }
    getLoginUserData() {
      let loginUserData = JSON.parse(localStorage.getItem("loginUser"));
      if (loginUserData) {
        this.accessToken = loginUserData["id"];
        this.userId = loginUserData["userId"];
      }
    }
  
  //   public getScope(): Array<any> | boolean {
  //     return this.scope;
  // }
  
  // public setScope(scope: any): void {
  //     this.scope = scope;
  // }
  
    getUser()
    {
      let LoginUrl =
      this.apiUrl +
      "Users/" ;
    return new Promise((resolve,reject)=>
    {
    this.http.get(LoginUrl,this.httpOptions).subscribe((res)=>
    {
      console.log('data');
      
      resolve(res);
    },
    (err)=>
    {
      reject(err)
    })
  })
  }
  loggedIn()
  {
    return !!localStorage.getItem('token');
  }
  
  
   verifyUser(user)
   {
    let LoginUrl =
        this.apiUrl +
        "users/login/" ;
      return new Promise((resolve,reject)=>
      {
      this.http.post(LoginUrl,user,this.httpOptions).subscribe((res:any)=>
      {
        
        localStorage.setItem('LoginId',res.userId)
        localStorage.setItem('token',res.token);
        localStorage.setItem("loginUser", JSON.stringify(res));
      
        console.log(res)
      resolve(res)
      },
      (err)=>
      {
        reject(err)
      })
    })
    }
  resetPassword(data)
  {
    let LoginUrl =
        this.apiUrl +
        "Users/" ;
      return new Promise((resolve,reject)=>
      {
      this.http.patch(LoginUrl,data,this.httpOptions).subscribe((res)=>
      {
        console.log('Password is updated');
        resolve(res);
      },
      (err)=>
      {
        reject(err)
      })
    })
    }
  getProfile(id)
  {
    
    let filterJSON = {};
  
    let filter = encodeURI(JSON.stringify(filterJSON));
   const url= this.apiUrl +
    "users/" +id+ "?access_token=" +
    this.accessToken +
    "&filter=" +
    filter;
  
    return new Promise ((resolve,reject)=>
    {
      this.http.get(url,this.httpOptions).subscribe((res:any)=>
      {
        localStorage.setItem('sadmin',res.sadmin)
        localStorage.setItem('username',JSON.stringify(res))
      resolve(res)
      },
      (err)=>
      {
        reject(err);
      }
      
      )
    })
   }
  updateProfile(id,data)
  { 
  let filterJSON = {};
  
  let filter = encodeURI(JSON.stringify(filterJSON));
  
  let ProfileUrl =this.apiUrl + "users/" + id;
  
  return new Promise ((resolve,reject)=>
  {
    this.http.patch(ProfileUrl,data,{
      headers: this.headers,
      withCredentials: true,
    }
  ).subscribe((res)=>
    {
      resolve(res);
    },
    (err)=>
    {
      reject(err);
    }
    
    )
  })
  }
  
  getMember()
  {
    let filterJSON = {};
  
    let filter = encodeURI(JSON.stringify(filterJSON));
   let url=this.apiUrl+'users/'+
   "?access_token=" +
   this.accessToken +
   "&filter=" +
   filter;;
   return new Promise((resolve,reject)=>
   {
   this.http.get(url,this.httpOptions).subscribe((res)=>
   {console.log("Member Is Fetche");
    resolve(res);
   },
   (err)=>
   {console.log("Try Again");
     reject(err);
   }
   
   )} )
  }
  
  
  getMemberDetail(id):any
  {
    let filterJSON = {};
  
    let filter = encodeURI(JSON.stringify(filterJSON));
   let url=this.apiUrl+'users/'+id+
   "?access_token=" +
   this.accessToken +
   "&filter=" +
   filter;
   return new Promise((resolve,reject)=>
   {
   this.http.get(url,this.httpOptions).subscribe((res)=>
   {console.log("Member Is get");
    resolve(res);
   },
   (err)=>
   {console.log("Try Again");
     reject(err);
   }
   
   )} )
  }
  
  
  editMemberDetail(id,data)
  {
    let filterJSON = {};
  
    let filter = encodeURI(JSON.stringify(filterJSON));
    let MemberUrl=this.apiUrl+'users/'+id+
    "?access_token=" +
    this.accessToken +
    "&filter=" +
    filter;
    return new Promise ((resolve,reject)=>
    {
      this.http.patch(MemberUrl,data,this.httpOptions).subscribe((res)=>
      {
        console.log("Member Is Updated");
        resolve(res)
      },
      (err)=>
      {
        console.log(" Try Again");
        reject(err);
      })
    })
  }
  
  deleteMemberDetail(id)
  {
    let filterJSON = {};
  
    let filter = encodeURI(JSON.stringify(filterJSON));
    let MemberUrl=this.apiUrl+'users/'+id+
    "?access_token=" +
    this.accessToken +
    "&filter=" +
    filter;
    return new Promise ((resolve,reject)=>
    {
      this.http.delete(MemberUrl,this.httpOptions).subscribe((res)=>
      {
        console.log("Member Is Deleted");
        resolve(res)
      },
      (err)=>
      {
        console.log(" Try Again");
        reject(err);
      })
    })
  }
  
  
   addMember(user)
   {
    let filterJSON = {};
  
    let filter = encodeURI(JSON.stringify(filterJSON));
    let MemberUrl=this.apiUrl+'users/'+
    "?access_token=" +
    this.accessToken +
    "&filter=" +
    filter;
    return new Promise ((resolve,reject)=>
    {
      this.http.post(MemberUrl,user,this.httpOptions).subscribe((res)=>
      {
        console.log("Member Is Added");
        resolve(res)
      },
      (err)=>
      {
        console.log(" Try Again");
        reject(err);
      })
    })
  }
  
   addNotification(data)
   {
    let filterJSON = {};
  
    let filter = encodeURI(JSON.stringify(filterJSON));
  
      let Notification=this.apiUrl+'notifications/'+ "?access_token=" +
      this.accessToken +
      "&filter=" +
      filter;
      return new Promise ((resolve,reject)=>
      {
        this.http.post(Notification,data,this.httpOptions).subscribe((res)=>
        {
          console.log("New Notification Is Added");
          resolve(res)
        },
        (err)=>
        {
          console.log(" Try Again");
          reject(err);
        })
      })
    }
   getNotifications()
   {
    let filterJSON = {};
  
    let filter = encodeURI(JSON.stringify(filterJSON));
    let url=this.apiUrl+'notifications' +"?access_token=" +
    this.accessToken +
    "&filter=" +
    filter;
     return new Promise((resolve,reject)=>
     {
     this.http.get(url,this.httpOptions).subscribe((res)=>
     {console.log("Notification Is Fetched");
      resolve(res);
     },
     (err)=>
     {console.log(" Try Again");
       reject(err);
     }
     
     )} )
    }
    
   deleteNotificationDetail(id)
  { let filterJSON = {};
  
  let filter = encodeURI(JSON.stringify(filterJSON));
  
   let url=this.apiUrl+'notifications/'+id +"?access_token=" +
   this.accessToken +
   "&filter=" +
   filter;
   return new Promise((resolve,reject)=>
   {
   this.http.delete(url,this.httpOptions).subscribe((res)=>
   {console.log("Notification Is Deleted");
    resolve(res);
   },
   (err)=>
   {console.log(" Try Again");
     reject(err);
   }
   
   )} )
  }
  
   }
    
  
  